import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';
import axios from "../../server/interceptors";
import {apiSubMainSubCodeCreate, DEFAULT_LANGUAGE} from '../../config';
import {Button, Container} from 'react-bootstrap';
import './create-subindicator-page-style.css';
import SessionManager from "../../utils/authHandling/session-manager";
import SubIndicatorDisplayView from "../../components/subIndicatorDisplayView";

class CreateSubindicatorPage extends Component {

    constructor(props){
        super(props);
        this.state={
            loading: false,
            id: "",
            code: "",
            languageSP: "",
            languageEN: "",
            selectedStandardId: "",
            selectedExpectationId: "",
            selectedSubjects: [],
            selectedGrade: [],
            redirect: false,
        };
        this.onCreateCall = this.onCreateCall.bind(this);
        this.onChange = this.onChange.bind(this);
        this.redirectToEdit = this.redirectToEdit.bind(this);
    }

    onChange(field, value){
        this.setState({[field]: value});
    }

    onCreateCall(){

        // Validate
        if(this.state.code === ""){
            alert("Error: The standard code is required. / El código estándar es requerido.");
            return;
        }
        if(this.state.languageSP.length === 0){
            alert("Error: The description in Spanish is required./La descripción en español es requerida.");
            return;
        }
        if(this.state.languageEN.length === 0){
            alert("Error: The description in English is required./La descripción en inglés es requerida.");
            return;
        }
        if(this.state.selectedSubCodeId === ''){
            alert("Error: The indicator id is required./El indicador es requerido.");
            return;
        }

        this.setState({loading: true}, ()=>{
            // Call the API to insert
            let params = {
                SubmainSubCodeModel: {
                    CodeSubmainId: this.state.selectedSubCodeId,
                    Code: this.state.code,
                    Desc: this.state.languageSP,
                },
                SubmainSubCodeLanguageModels:[
                    {
                        LessonLangCode: "es",
                        Desc: this.state.languageSP,
                    },
                    {
                        LessonLangCode: "en",
                        Desc: this.state.languageEN,
                    }
                ]
            };

            axios.post(apiSubMainSubCodeCreate, params,{
                headers: {
                    'Content-Type': 'application/json',                    
                }}).then((response)=>{

                if(response.status === 201)
                {
                    alert("Successfully created./Creado satisfactoriamente.");
                    this.setState({
                        redirect: true,
                    })
                }
                else
                {
                    alert("Validate the fields. If the error continues, contact the administrator./Valide los campos. Si el error persiste, contacte al administrador.");
                }
                this.setState({loading: false});
            }).catch(error => {

                if(error.response.status === 400)
                {
                    if(typeof error.response.data !== 'undefined' && typeof error.response.data.Messages !== 'undefined' && error.response.data.Messages.length > 0)
                    {
                        let message = "";
                        for(let i=0;i<  error.response.data.Messages.length; i++)
                        {
                            message += error.response.data.Messages[i];
                        }
                        alert(message);
                    }
                }
                else {
                    alert(`Error: ${error}`);
                }
                this.setState({loading: false});
            });
        });
    }

    redirectToEdit(){
        this.setState({redirectToEdit: true})
    }

    render(){
        if(this.state.redirect){
            return <Redirect to='/view-sub-indicators' />
        }

        return(
            <Container fluid className="card-alt">
                <div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <h2><FormattedMessage id="std-sub-indicator"/></h2>
                        {this.state.loading ? <Button disabled variant="success">
                                <FormattedMessage id="std-sub-indicator-create"/></Button> :
                            <Button variant="success" onClick={this.onCreateCall}>
                                <FormattedMessage id="std-sub-indicator-create"/>
                            </Button>}
                    </div>

                    <SubIndicatorDisplayView
                        isCreation={true}
                        language={this.props.language}
                        dataContent={this.state}
                        onChange={this.onChange}
                    />
                </div>
            </Container>
        );
    }
}

export default CreateSubindicatorPage;